import React, { useState } from "react";
import UsersListTable from "./components/table/userTable";
import { Button, Group, Title } from "@mantine/core";
import { UserPlus } from "tabler-icons-react";
import AdduserModal from "./components/adduser";
import { useAllGetUsersAndPermissions } from "api/permission/getAllUsersAndPermissions";
import Loader from "components/Loader";

export default function UserFeature() {
  const [opened, setOpened] = useState(false);
  const { isLoading } = useAllGetUsersAndPermissions();
  if (isLoading) return <Loader />;

  return (
    <div>
      <Group position="apart" mb="md">
        <Title order={2}>User Permissions</Title>
      </Group>

      <UsersListTable />
      <AdduserModal opened={opened} onClose={() => setOpened(false)} />
    </div>
  );
}
